import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import store from '@/store/store';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import Router from '@/Router';
import Messages from '@/assets/ts/utils/Messages';
import { ExportRelatController } from './ExportRelatController';
import { Column } from '@zeedhi/common';

interface SolicitacaoAprovacao {
  NRSOLICITACAO:              string,
  NRTIPOSOLICITACAO:          string,
  NRVINCULOM:                 string,
  NMVINCULOM:                 string,
  NMFASEAPROVSOLI:            string,
  NMTIPOSOLICITACAO:          string,
  DSOBSERVACAO?:              string,
  IDAPROVACAO?:               'A' | 'R' | 'C';
  NRFASEAPROVSOLI?:           string,
  NRORDEM?:                   string,
  ID_OPER_APROVA_SOLI?:       string,
  ID_FASE_SEGUINTE_EXISTS?:   string,
  NRFASEAPROVSOLI_SEGUINTE?:  string,
  NMFASEAPROVSOLI_SEGUINTE?:  string,
  IDANEXODOCUMENTO?:          'S' | 'N',
  CDTIPOREPROVACAO?:          'I' | 'A',
  IDFASEOBRIGATORIA?:         'S' | 'N',
  EXTRA_ROW?: {
    CDSTATUS?: string,
    FILES?: []
  },
}

enum TiposSolicitacao {
  /* Especificos org. 20 */
  TP_SOLI_FARMACIA               = '-1',
  TP_SOLI_CARTAO                 = '-2',
  TP_SOLI_ALIMENTACAO            = '-3',
  /* Gerais */
  TP_SOLI_FERIAS                 = '1',
  TP_SOLI_MOVIM_LEGAL            = '2',
  TP_SOLI_SALARIO                = '3',
  TP_SOLI_TREINAMENTO            = '4',
  TP_SOLI_DESLIGAMENTO           = '5',
  TP_SOLI_PESSOAL                = '6',
  TP_SOLI_ALTERADADOS            = '7',
  TP_SOLI_ALTERAENDERECO         = '8',
  TP_SOLI_MOVIM_OCUPACAO_SALARIO = '9',
  TP_SOLI_VTRANS                 = '10',
  TP_SOLI_DEP                    = '11',
  TP_SOLI_ALTESITU               = '12',
  TP_SOLI_PLANOSAUDE             = '13',
  TP_SOLI_ALTERAESCALA           = '14',
  TP_SOLI_ALTERACONTA            = '15',
  TP_SOLI_ALTERACOMU             = '16',
  TP_SOLI_ADMISSAO               = '17',
  TP_SOLI_APROVAHE               = '18',
  TP_SOLI_REEMBOLSO              = '19',
  TP_SOLI_ADVERTENCIA            = '20',
  TP_SOLI_VCOMBUST               = '21',
  TP_SOLI_AUXILIOMORADIA         = '22',
  TP_SOLI_VMANUTENCAO            = '23',
  TP_SOLI_BENEFICIOS             = '24',
  TP_SOLI_SUBSTITUICAO           = '25',
  TP_SOLI_MOVIM_GERENCIAL        = '26',
  TP_SOLI_OCUPACAO               = '27',
  TP_SOLI_AUMENTO_QUADRO         = '28',
  TP_SOLI_SALARIO_ESCALA         = '29',
  TP_SOLI_ADVERTENCIA_ANOT_VINC  = '30',
}

class SolicitacaoController {

  public static redirectToSolicitacaoFiltered() {
    Router.push({ path: '/solicitacao', query: { filterAprovStatus: 's' } });
  }

  public static async aprovaVariasSolicitacoes(
    solicitacoes: SolicitacaoAprovacao[],
    showLoading: boolean = false
  ): Promise<any> {

    const response = await HttpRequest.post('aprovaVariasSolicitacoes', {
      requestType: 'Row',
      NRORG: store.getters.user.nrorg,
      row: solicitacoes,
    }, showLoading);

    if (response.data && response.data.dataset && response.data.dataset.data) {
      const data = response.data.dataset.data;
      if(data.ERRORS && data.ERRORS.length) {
        const msg = data.ERRORS.reduce((accum: string, error: string, i: number) => (
          `${accum}${error}<br>\n`
        ), '');

        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR, 10000);

        if(data.ERRORS.length < solicitacoes.length) {
          SnackbarUtils.showMessage('As demais solicitações foram aprovadas com sucesso!', SnackbarUtils.TYPE_SUCCESS, 12000);
        }

      }

      if(data.ERRORS && !data.ERRORS.length) {
        SnackbarUtils.showMessage(Messages.SOLI_APROV_SUCCESS, SnackbarUtils.TYPE_SUCCESS);
      }


      solicitacoes.forEach((soli) => {
        if(soli.ID_OPER_APROVA_SOLI == 'S' && !data.ERROR_NRSOLICITACOES.includes(soli.NRSOLICITACAO)) {
          this.notificaProximosAprovadoresSolicitacao(
            soli.NRSOLICITACAO, false
          );
        }
      });
      
    }

    return response;
  }

  public static async reprovaVariasSolicitacoes(
    solicitacoes: SolicitacaoAprovacao[],
    showLoading: boolean = false
  ): Promise<any> {

    const response = await HttpRequest.post('reprovaVariasSolicitacoes', {
      requestType: 'Row',
      NRORG: store.getters.user.nrorg,
      row: solicitacoes,
    }, showLoading);

    if (response.data && response.data.dataset && response.data.dataset.data) {
      const data = response.data.dataset.data;
      if(data.ERRORS && data.ERRORS.length) {
        const msg = data.ERRORS.reduce((accum: string, error: string, i: number) => (
          `${i + 1} - ${accum}${error}<br>\n`
        ), '');

        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR, 10000);

        if(data.ERRORS.length < solicitacoes.length) {
          SnackbarUtils.showMessage('As demais solicitações foram reprovadas com sucesso!', SnackbarUtils.TYPE_SUCCESS, 12000);
        }

      }

      if(data.ERRORS && !data.ERRORS.length) {
        SnackbarUtils.showMessage(Messages.SOLI_REPROV_SUCCESS, SnackbarUtils.TYPE_SUCCESS);
      }

      solicitacoes.forEach((soli) => {
        if(soli.ID_OPER_APROVA_SOLI == 'S' && !data.ERROR_NRSOLICITACOES.includes(soli.NRSOLICITACAO)) {
          this.notificaOperadoresReprovacao(
            soli.NRSOLICITACAO, false
          );
        }
      });
      
    }

    return response;
  }

  public static async aprovaSolicitacao(
    solicitacao: SolicitacaoAprovacao,
    showLoading: boolean = false
  ): Promise<any> {
    const response = await HttpRequest.post('aprovaSolicitacao', {
      requestType: 'Row',
      row: {
          NRORG: store.getters.user.nrorg,
          NRSOLICITACAO: solicitacao.NRSOLICITACAO,
          CDOPERADOR_APROVANTE: store.getters.user.cdoperador,
          DSOBSERVACAO: solicitacao.DSOBSERVACAO || null,
          EXTRA_ROW: solicitacao.EXTRA_ROW,
        },
    }, showLoading);

    if (response.data && response.data.dataset && response.data.dataset.data) {
      this.notificaProximosAprovadoresSolicitacao(
        solicitacao.NRSOLICITACAO, false
      );
    }

    return response;
  }

  public static async reprovaSolicitacao(
    solicitacao: SolicitacaoAprovacao,
    showLoading: boolean = false
  ): Promise<any> {
    const response = await HttpRequest.post('reprovaSolicitacao', {
      requestType: 'Row',
      row: {
          NRORG: store.getters.user.nrorg,
          NRSOLICITACAO: solicitacao.NRSOLICITACAO,
          CDOPERADOR_APROVANTE: store.getters.user.cdoperador,
          DSOBSERVACAO: solicitacao.DSOBSERVACAO || null,
          CDTIPOREPROVACAO: solicitacao.CDTIPOREPROVACAO,
          EXTRA_ROW: solicitacao.EXTRA_ROW,
        },
    }, showLoading);

    if (response.data && response.data.dataset && response.data.dataset.data) {
      this.notificaOperadoresReprovacao(
        solicitacao.NRSOLICITACAO, false
      );
    }

    return response;
  }

  public static async cancelaSolicitacaoDesligamento(
    solicitacao: SolicitacaoAprovacao,
    showLoading: boolean = false
  ): Promise<any> {
    const response = await HttpRequest.post('cancelaSolicitacaoDesligamento', {
      requestType: 'Row',
      NRORG: store.getters.user.nrorg,
      row: {
          NRSOLICITACAO: solicitacao.NRSOLICITACAO,
          NRVINCULOM: solicitacao.NRVINCULOM,
          CDOPERADOR_APROVANTE: store.getters.user.cdoperador,
          DSOBSERVACAO: solicitacao.DSOBSERVACAO || null,
          EXTRA_ROW: solicitacao.EXTRA_ROW,
          NRPERIODO:  store.state.periodoDemonstrativoAtual,
        },
    }, showLoading);

    return response;
  }

  public static async notificaProximosAprovadoresSolicitacao(
    nrSolicitacao: string,
    showLoading: boolean = false
  ): Promise<any> {
    const response = await HttpRequest.post('notificaProximosAprovadoresSolicitacao', {
      requestType: 'Row',
      NRORG: store.getters.user.nrorg,
      row: {
          NRSOLICITACAO: nrSolicitacao,
        },
    }, showLoading);

    return response;
  }

  public static async notificaOperadoresReprovacao(
    nrSolicitacao: string,
    showLoading: boolean = false
  ): Promise<any> {
    const response = await HttpRequest.post('notificaOperadoresReprovacao', {
      requestType: 'Row',
      NRORG: store.getters.user.nrorg,
      row: {
          NRSOLICITACAO: nrSolicitacao,
        },
    }, showLoading);

    return response;
  }

  public static async getSolicitacaoFile(
    nrSolicitacao: string,
  ) {
    const nrOrg = this.getNrOrg();
    const route = 'getSolicitacaoFile';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRSOLICITACAO: nrSolicitacao,
    };

    try {
      const response = await HttpRequest.get(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const fileData = response.data.dataset.data;

      return fileData;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo.';
      SnackbarUtils.showMessage(message, 'error');

      throw err;
    }
  }

  private static getNrOrg(): number {
    const nrOrg = store.getters.user.nrorg;
    const nrOrgInt = parseInt(nrOrg, 10);

    return nrOrgInt;
  }

  public static async getFasesSolicitacao(
    nrSolicitacao: string,
    showLoading: boolean = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getFasesSolicitacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRSOLICITACAO: nrSolicitacao,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const fasesSolicitacao: any[] = response.data.dataset.data;

      return fasesSolicitacao;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar as fases da solicitação';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getItemSolicitacao(
    nrSolicitacao: string,
    showLoading: boolean = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getItemSolicitacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRSOLICITACAO: nrSolicitacao,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const itensSolicitacao: any[] = response.data.dataset.data;

      return itensSolicitacao;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar os itens da solicitação';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTipoBeneficio(
    showLoading = true,
  ): Promise<any[]> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getTipoBeneficio';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const tiposBeneficio: any[] = response.data.dataset.data;
  
      return tiposBeneficio;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar os tipos de benefícios.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getBeneficiosVCombust(
    showLoading = true,
  ): Promise<any[]> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getBeneficiosVCombust';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const beneficios: any[] = response.data.dataset.data;
  
      return beneficios;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar os benefícios.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getBeneficiosVManutencao(
    showLoading = true,
  ): Promise<any[]> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getBeneficiosVManutencao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const beneficios: any[] = response.data.dataset.data;
  
      return beneficios;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar os benefícios.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async verificaTipoTransferencia(
    nrTipoTransf: string,
    nrTipoEstrutura: string,
    showLoading: boolean = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'verificaTipoTransferencia';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRTIPOTRANSFER: nrTipoTransf,
      NRTIPOESTRUTURA: nrTipoEstrutura
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const validado: any[] = response.data.dataset.data;

      return validado;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Ocorreu um erro ao verificiar se o tipo de estrutura e compatível com a estrutura';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSolicitacaoSubstituicaoOrVinculoSubst(
    nrVinculo,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getSolicitacaoSubstituicaoOrVinculoSubst';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const data: any = response.data.dataset.data;
  
      return data;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível verificar se já possui alguma solicitação de substituição para esse vínculo.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async setDataSoliSubstituicaoVinculo(
    nrVinculo,
    nrSolicitacao,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'setDataSoliSubstituicaoVinculo';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      NRSOLICITACAO: nrSolicitacao
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const data: any = response.data.dataset.data;
  
      return data;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível salvar os dados do novo vínculo na solicitação de substituição.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getFolhaFechada(
    nrVinculo,
    dtAlteracao,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getFolhaFechada';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      DTALTERACAO: dtAlteracao
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const data: any = response.data.dataset.data;
  
      return data;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível verificar se a folha está fechada.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getHierarquiaByEstruturaLegalAndGeren(
    nrEstrutLegal,
    nrEstrutGeren,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getHierarquiaByEstruturaLegalAndGeren';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESTRUTLEGAL: nrEstrutLegal,
      NRESTRUTGEREN: nrEstrutGeren
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const data: any = response.data.dataset.data;
  
      return data;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível verificar se a Estrututa Gerencial está sobre a hierarquia da Estrutua Legal.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getGozoFeriasVinculo(
    nrVinculom,
    nrFerias,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getGozoFeriasVinculo';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculom,
      NRFERIAS: nrFerias
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const data: any = response.data.dataset.data;
  
      return data;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar as informações das férias.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getDadosVinculo(
    nrvinculom: number,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getDadosVinculo';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrvinculom
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const dados: any = response.data.dataset.data;
  
      return dados;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar os dados do vínculo.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSolicitacoesAdmissao(
    showLoading = true,
  ): Promise<any[]> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'getSolicitacoesAdmissao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const dados: any[] = response.data.dataset.data;
  
      return dados;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar as solicitações de admissão.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTodosVinculosRescindidos(): Promise<any[]> {
    const route = 'getTodosVinculosRescindidos';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const data = response.data;

      ExpectedError.throwResponseError(response);

      return data.dataset.data;
    } catch (err) {
      const message = err instanceof Error ?
        err.message :
        'Não foi possível carregar os vínculos!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async exportData(
    data: any,
    type: string,
    name: string
  ): Promise<boolean>  {
    try {
      
      let columns = [];

      if(type == 'pdf') {
        columns = [
          "N° Vínculo",
          "Vínculo",
          "Estrutura Legal",
          "Estrutura Gerencial",
          "N° Solicitação",
          "Data de Solicitação",
          "Tipo de Solicitação",
          "Status da Solicitação",
          "Próxima Fase",
          "Observação",
        ];
      } else if(type == 'xls'){
        columns = [
          "N° Vínculo",
          "Vínculo",
          "Estrutura Legal",
          "Estrutura Gerencial",
          "N° Solicitação",
          "Data de Solicitação",
          "Tipo de Solicitação",
          "Status da Solicitação",
          "Próxima Fase",
          "Observação",
        ];

        let aux = [columns];
        data = aux.concat(data);
      }

      await ExportRelatController.exportData(data, type, name, columns, null);

      return true;
    } catch (err) {
      const e = err as any;
      const message = e.message;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generatePdfReport(
    fileName: string,
    title: string,
    data: any,
    columns: string[],
    columnMapping: Record<string, string>
  ): Promise<boolean>  {
    try {

      ExportRelatController.generatePDF(fileName, title, data, columns, columnMapping);

      return true;
    } catch (err) {
      const e = err as any;
      const message = e.message;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generateXlsxReport(
    fileName: string,
    data: any,
    columns: string[],
    columnMapping: Record<string, string>,
    columnWidths?: Record<string, number>
  ): Promise<boolean>  {
    try {

      ExportRelatController.generateXLSX(fileName, data, columns, columnMapping, columnWidths);

      return true;
    } catch (err) {
      const e = err as any;
      const message = e.message;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSolicitacoesSelect(
    payload,
    showLoading = true,
  ): Promise<any[]> {
    const nrOrg: string = store.getters.user.nrorg;

    const {
      NRTIPOSOLICITACAO,
      NRESTRUTLEGAL,
      NRESTRUTGEREN,
      NRVINCULOM
    } = payload;

    const route = 'getSolicitacoesSelect';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRTIPOSOLICITACAO,
      NRESTRUTLEGAL,
      NRESTRUTGEREN,
      NRVINCULOM,
      NRPERIODOAPURACAO: store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);
  
      const beneficios: any[] = response.data.dataset.data;
  
      return beneficios;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error : 'Não foi possível buscar as solicitações.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generateSolicitacaoCustomReportXLS(
    nrSolicitacoes,
    showLoading = true,
  ): Promise<any> {
    const nrOrg: string = store.getters.user.nrorg;

    const route = 'generateSolicitacaoCustomReportXLS';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRSOLICITACOES: nrSolicitacoes,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const file: {
        fileName: string;
        base64: string;
        type: string;
      } = response.data.dataset.data;

      if (!file.fileName || !file.base64 || !file.type) {
        throw new Error('Arquivo recebido inválido ou incompleto.');
      }
  
      return file;

    } catch (err) {
      const msgDefault = 'Não foi possível gerar o relatório da solicitação!';
      const message = err && (err as any).response ? (err as any).response.data.error : msgDefault;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      console.error('Erro ao gerar relatório:', err);

      throw err;
    }
  }
}

export { SolicitacaoAprovacao, SolicitacaoController, TiposSolicitacao };
